import { Color } from "../models/helpers/colors.ts"

const ProgressBar = ({ percent, label, smallText, color = Color.success }: { percent: number, label: string, smallText?: string, color?: Color }) => {
    return (
        <div>
            <h6>{label}</h6>
            <div className="progress" style={{ width: "100%" }}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={
                        {
                            width: `${percent}%`,
                            backgroundColor: percent > 100 ? Color.danger : color
                        }
                    }
                    aria-valuenow={percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                />
            </div>
            <p>{smallText}</p>
        </div>
    )
}

export default ProgressBar